import { email, required } from 'vuelidate/lib/validators';
import phone from '@/validators/rule/phone';

export default {
  phone: {
    required,
    phone
  },
  email: {
    required,
    email
  }
}
